import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    class: "sc-upload-multiple"
};
const _hoisted_2 = {
    key: 0,
    class: "el-upload__tip"
};
const _hoisted_3 = {
    class: "sc-upload-list-item"
};
const _hoisted_4 = {
    key: 0,
    class: "sc-upload__item-actions"
};
const _hoisted_5 = [
    "onClick"
];
const _hoisted_6 = {
    key: 1,
    class: "sc-upload__item-progress"
};
const _hoisted_7 = {
    style: {
        "display": "none!important"
    }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_icon_plus = _resolveComponent("el-icon-plus");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_image = _resolveComponent("el-image");
    const _component_el_icon_delete = _resolveComponent("el-icon-delete");
    const _component_el_progress = _resolveComponent("el-progress");
    const _component_el_upload = _resolveComponent("el-upload");
    const _component_el_input = _resolveComponent("el-input");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_upload, {
            ref: "uploader",
            "list-type": "picture-card",
            "auto-upload": $props.autoUpload,
            disabled: $props.disabled,
            action: $props.action,
            name: $props.name,
            data: $props.data,
            "http-request": $options.request,
            "file-list": $data.defaultFileList,
            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event)=>$data.defaultFileList = $event),
            "show-file-list": $props.showFileList,
            accept: $props.accept,
            multiple: $props.multiple,
            limit: $props.limit,
            "before-upload": $options.before,
            "on-success": $options.success,
            "on-error": $options.error,
            "on-preview": $options.handlePreview,
            "on-exceed": $options.handleExceed
        }, {
            tip: _withCtx(()=>[
                    $props.tip ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.tip), 1)) : _createCommentVNode("", true)
                ]),
            file: _withCtx(({ file })=>[
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_image, {
                            class: "el-upload-list__item-thumbnail",
                            src: file.url,
                            fit: "cover",
                            "preview-src-list": $options.preview,
                            "initial-index": $options.preview.findIndex((n)=>n == file.url),
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 9999
                        }, {
                            placeholder: _withCtx(()=>[
                                    ..._cache[2] || (_cache[2] = [
                                        _createElementVNode("div", {
                                            class: "sc-upload-multiple-image-slot"
                                        }, " Loading... ", -1)
                                    ])
                                ]),
                            _: 1
                        }, 8, [
                            "src",
                            "preview-src-list",
                            "initial-index"
                        ]),
                        !$props.disabled && file.status == 'success' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("span", {
                                class: "del",
                                onClick: ($event)=>$options.handleRemove(file)
                            }, [
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_el_icon_delete)
                                        ]),
                                    _: 1
                                })
                            ], 8, _hoisted_5)
                        ])) : _createCommentVNode("", true),
                        file.status == 'ready' || file.status == 'uploading' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_el_progress, {
                                percentage: file.percentage,
                                "text-inside": true,
                                "stroke-width": 16
                            }, null, 8, [
                                "percentage"
                            ])
                        ])) : _createCommentVNode("", true)
                    ])
                ]),
            default: _withCtx(()=>[
                    _renderSlot(_ctx.$slots, "default", {}, ()=>[
                            _createVNode(_component_el_icon, null, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_icon_plus)
                                    ]),
                                _: 1
                            })
                        ], true)
                ]),
            _: 3
        }, 8, [
            "auto-upload",
            "disabled",
            "action",
            "name",
            "data",
            "http-request",
            "file-list",
            "show-file-list",
            "accept",
            "multiple",
            "limit",
            "before-upload",
            "on-success",
            "on-error",
            "on-preview",
            "on-exceed"
        ]),
        _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_el_input, {
                modelValue: $data.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.value = $event)
            }, null, 8, [
                "modelValue"
            ])
        ])
    ]);
}
